// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jG_u","question":"styles_question__18ExP","inputVisibleButton":"styles_inputVisibleButton__3cdwO","note":"styles_note__38gI3"};